import './components/share'

import './scss/st19/styles.scss'
